module.exports = __webpack_public_path__ + "static/zorana-183c94d91b7b3f9167212c27a706b4bf.jpg";